import type { AppbarActionProps } from "react-native-paper";

import Icon from "@expo/vector-icons/MaterialCommunityIcons";
import { Appbar } from "react-native-paper";
import type { IconType } from "../types";

type Props = AppbarActionProps & {
	icon: IconType;
};

const AppbarAction = (props: Props) => {
	const { icon, ...rest } = props;
	return (
		<Appbar.Action
			{...rest}
			icon={(props) => <Icon name={icon} {...props} />}
		/>
	);
};

export default AppbarAction;
